module.exports = __webpack_public_path__ + "media/Instruction_A43.7738c6ba.mp3";